'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    SET_FUNCTIONS_LISTA_DE_USUARIOS,
    GET_DATA_LISTA_USUARIOS_START,
    GET_DATA_LISTA_USUARIOS_SUCCESS,
    SEARCH_USER_FROM_LISTA_USUARIOS,
    SET_ACTIVOS_CHECKBOX_FROM_LISTA_USUARIOS,
    SET_BLOQUEADOS_CHECKBOX_FROM_LISTA_USUARIOS,
    SET_ELIMINADOS_CHECKBOX_FROM_LISTA_USUARIOS,
    ORDER_COLUMN_FROM_LISTA_USUARIOS,
    SET_ALL_CHECKBOX_FROM_LISTA_USUARIOS,
    SET_CHECKBOX_FROM_LISTA_USUARIOS,
    INITIAL_STATE_LISTA_USUARIOS,
    REINICIAR_CHECKS,
    GET_DATA_LISTA_USUARIOS_NOT_SUCCESS
} from '../../Screens/ListaDeUsuarios/actions/ListaDeUsuarios';

const initialState = {
    currentUser: null,
    isFetching: false,
    functions: undefined,
    usuarios: undefined,
    usuariosFiltrados: undefined,
    usuariosSeleccionados: [],
    searchFilter: "",
    activoFilter: true,
    bloqueadoFilter: true,
    eliminadoFilter: true,
    allCheckboxFilter: false,
    column: [{ "name": "nombre", "state": false }, { "name": "login", "state": true }, { "name": "sucursal", "state": true }, { "name": "sector", "state": true }],
    columnIndex: 0,
    isCurrentUser: undefined,
    checkBloqueado: true,
    checkActivo: true,
    checkBorrado: true,
};


function listaDeUsuarios(state = initialState, action) {
    LogHelper.In(listaDeUsuarios.name, state, action);

    let result;
    let usuariosFiltrados, usuariosTemp, temp = null;
    let usuariosSeleccionadosTemp = [];

    switch (action.type) {

        case SET_FUNCTIONS_LISTA_DE_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case GET_DATA_LISTA_USUARIOS_START:
            LogHelper.In(listaDeUsuarios.name, state, action);

            result = {
                ...state,
                currentUser: action.currentUser,
                currentUserLogin: action.currentUserLogin,
                isFetching: true
            };
            break;

        case REINICIAR_CHECKS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            let usuariosOriginales = usuariosFilter(state, null, null, null, null, null, null, null);

            result = {
                ...state,
                checkBloqueado: true,
                checkActivo: true,
                checkBorrado: true,
                activoFilter: true,
                bloqueadoFilter: true,
                eliminadoFilter: true,
                usuariosFiltrados: usuariosOriginales
            };
            break;

        case GET_DATA_LISTA_USUARIOS_SUCCESS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            let tempResult = action.result;
            tempResult.forEach(p => { p.Seleccionado = false; });

            state.usuarios = tempResult;
            usuariosFiltrados = usuariosFilter(state, null, state.activoFilter, state.bloqueadoFilter, state.eliminadoFilter, null, null, null);    
            usuariosFiltrados.forEach(u => { u.Seleccionado = false; });
            
            if(state.allCheckboxFilter)
                state.allCheckboxFilter = false;

            result = {
                ...state,
                isFetching: false,
                usuarios: tempResult,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: []
            };
            break;
        case GET_DATA_LISTA_USUARIOS_NOT_SUCCESS:

            result = {
                ...state,
                isFetching: false,
            };
            break;

        case SEARCH_USER_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            usuariosFiltrados = usuariosFilter(state, action.user, null, null, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                searchFilter: action.user
            };
            break;

        case SET_ACTIVOS_CHECKBOX_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, action.activo, null, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                activoFilter: action.activo,
                checkActivo: action.activo
            };
            break;

        case SET_BLOQUEADOS_CHECKBOX_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, null, action.bloqueado, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                bloqueadoFilter: action.bloqueado,
                checkBloqueado: action.bloqueado
            };
            break;

        case SET_ELIMINADOS_CHECKBOX_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, null, null, action.eliminado, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                eliminadoFilter: action.eliminado,
                checkBorrado: action.eliminado
            };
            break;

        case ORDER_COLUMN_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            let columnTemp = JSON.parse(JSON.stringify(state.column));
            columnTemp[action.columnIndex].state = !columnTemp[action.columnIndex].state;

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, action.columnIndex, columnTemp, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                columnIndex: action.columnIndex,
                column: columnTemp
            };
            break;

        case SET_ALL_CHECKBOX_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            let usuariosTemp = JSON.parse(JSON.stringify(state.usuarios));
            let usuariosSeleccionadosTemp = JSON.parse(JSON.stringify(state.usuariosSeleccionados));

            if (action.allCheckboxFilter == true) {
                usuariosTemp.forEach(function (item) {
                    if (action.currentUser != item.Id)
                        usuariosSeleccionadosTemp.push(item);
                })
            } else {
                usuariosSeleccionadosTemp = [];
            }

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, null, null, usuariosSeleccionadosTemp);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: usuariosSeleccionadosTemp,
                allCheckboxFilter: action.allCheckboxFilter
            };
            break;

        case SET_CHECKBOX_FROM_LISTA_USUARIOS:
            LogHelper.In(listaDeUsuarios.name, state, action);

            usuariosTemp = JSON.parse(JSON.stringify(state.usuarios));
            usuariosSeleccionadosTemp = JSON.parse(JSON.stringify(state.usuariosSeleccionados));

            let temp = usuariosSeleccionadosTemp.find(x => x.Id == action.usuarioId);
            if (temp != undefined) {
                usuariosSeleccionadosTemp.forEach(function (item, index, object) {
                    if (item.Id == action.usuarioId)
                        object.splice(index, 1);
                })
            } else {
                usuariosTemp.forEach(function (item) {
                    if (item.Id == action.usuarioId)
                        usuariosSeleccionadosTemp.push(item);
                })
            }

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, null, null, usuariosSeleccionadosTemp);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: usuariosSeleccionadosTemp
            };
            break;

        case INITIAL_STATE_LISTA_USUARIOS:
            result = initialState;
            break;

        default:
            LogHelper.In(listaDeUsuarios.name, state, action);
            result = {
                ...state
            }
            break;
    }

    LogHelper.Out(listaDeUsuarios.name, result);
    return result;
}

export default listaDeUsuarios;

/**------------------------------------------------------ FUNCIONES AUXILIARES --------------------------------------------------------**/

/**
 * Funcion general de filtrado que realiza (busqueda por nombre, por filtros y ordenamiento de columnas ascendente y descendente).
 * @param {any} state
 * @param {any} searchFilter
 * @param {any} activoFilter
 * @param {any} bloqueadoFilter
 * @param {any} eliminadoFilter
 * @param {any} columnIndex
 * @param {any} column
 * @param {any} usuariosSeleccionados
 */
function usuariosFilter(state, searchFilter, activoFilter, bloqueadoFilter, eliminadoFilter, columnIndex, column, usuariosSeleccionados) {
    LogHelper.In(usuariosFilter.name, state, searchFilter, activoFilter, bloqueadoFilter, eliminadoFilter, columnIndex, column, usuariosSeleccionados);

    //Obtengo valores y si no los recibi por parametro uso los que ya existen en el state.
    let usuariosFiltrados = JSON.parse(JSON.stringify(state.usuarios));

    searchFilter = searchFilter != null ? searchFilter : state.searchFilter;
    activoFilter = activoFilter != null ? activoFilter : state.activoFilter;
    bloqueadoFilter = bloqueadoFilter != null ? bloqueadoFilter : state.bloqueadoFilter;
    eliminadoFilter = eliminadoFilter != null ? eliminadoFilter : state.eliminadoFilter;
    columnIndex = columnIndex != null ? columnIndex : state.columnIndex;
    column = column != null ? column : state.column;
    usuariosSeleccionados = usuariosSeleccionados != null ? usuariosSeleccionados : state.usuariosSeleccionados;

    //Filtro por nombre o login de usuario.
    if (searchFilter != "")
        usuariosFiltrados = usuariosFiltrados.filter(x => x.Nombre.toUpperCase().includes(searchFilter.toUpperCase()) || x.Login.toUpperCase().includes(searchFilter.toUpperCase()));

    //Filtro por checkboxes de Activo, Bloqueado, Eliminado.
    let filteredRows = [];
    usuariosFiltrados.forEach(function (row) {
        //Activo
        if (activoFilter == true && bloqueadoFilter == false && eliminadoFilter == false) {
            if (row.Activo == true && row.Bloqueado == false) {
                filteredRows.push(row);
                return;
            }
        }
        //Bloqueado
        if (activoFilter == false && bloqueadoFilter == true && eliminadoFilter == false) {
            if (row.Activo == false && row.Bloqueado == true || row.Bloqueado_Inactividad == true) {
                filteredRows.push(row);
                return;
            }
        }
        //Eliminado
        if (activoFilter == false && bloqueadoFilter == false && eliminadoFilter == true) {
            if (row.Activo == false && row.Bloqueado == false) {
                filteredRows.push(row);
                return;
            }
        }
        //Activo y Bloqueado
        if (activoFilter == true && bloqueadoFilter == true && eliminadoFilter == false) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == true)) {
                filteredRows.push(row);
                return;
            }
        }
        //Activo y Eliminado
        if (activoFilter == true && bloqueadoFilter == false && eliminadoFilter == true) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == false)) {
                filteredRows.push(row);
                return;
            }
        }
        //Bloqueado y Eliminado
        if (activoFilter == false && bloqueadoFilter == true && eliminadoFilter == true) {
            if ((row.Activo == false && row.Bloqueado == true) || (row.Activo == false && row.Bloqueado == false)) {
                filteredRows.push(row);
                return;
            }
        }
        //Activo, Bloqueado y Eliminado
        if (activoFilter == true && bloqueadoFilter == true && eliminadoFilter == true) {
            filteredRows.push(row);
            return;
        }

        usuariosFiltrados = filteredRows;
    });

    //Filtro por columna y ejecuto el Sort en cada caso.
    if (column[columnIndex].state == true) {
        usuariosFiltrados = usuariosFiltrados.sort(function (a, b) {
            return sortArray(columnIndex, a, b, -1, 1);
        });
    } else {
        usuariosFiltrados = usuariosFiltrados.sort(function (a, b) {
            return sortArray(columnIndex, a, b, 1, -1);
        });
    }

    //Filtro por checkboxes seleccionados.
    usuariosFiltrados.forEach(function (item) {
        usuariosSeleccionados.forEach(function (item2) {
            if (item.Id == item2.Id)
                item.Seleccionado = true;
        })
    })

    LogHelper.Out(usuariosFilter.name, usuariosFiltrados);
    return usuariosFiltrados;
}

/**
 * Ordena la información de manera ascendente o descendente según los parametros recibidos.
 * @param {any} columnIndex - Indice que indica la columna de la tabla que fue clickeada.
 * @param {any} a
 * @param {any} b
 * @param {any} asc
 * @param {any} desc
 */
function sortArray(columnIndex, a, b, asc, desc) {
    LogHelper.In(sortArray.name, a, b, asc, desc);

    let firstRow = "";
    let SecondRow = "";
    switch (columnIndex) {
        case 0:
            firstRow = a.Nombre.toUpperCase();
            SecondRow = b.Nombre.toUpperCase();
            break;
        case 1:
            firstRow = a.Login.toUpperCase();
            SecondRow = b.Login.toUpperCase();
            break;
        case 2:
            firstRow = a.SUCURSAL.toUpperCase();
            SecondRow = b.SUCURSAL.toUpperCase();
            break;
        case 3:
            firstRow = a.SECTOR.toUpperCase();
            SecondRow = b.SECTOR.toUpperCase();
            break;
    }

    if (firstRow > SecondRow) {
        return asc;
    }
    if (firstRow < SecondRow) {
        return desc;
    }

    LogHelper.Out(sortArray.name, 0);
    return 0;
}